<template>
<div>
  <div class="title">
    <span class="link">应用管理 ></span> <span class="curLink" @click="goMyApp">我的应用 </span>
   </div>
   <!-- <div class="tabList">
        <div class="tab" v-for="(item, index) in tabList" :key="index" @click="tabMenu(index)"
          :class="{'activeIndex': active == index}">
          {{item.name}}
        </div>
        <div v-if="active === 1" class="TopRightBox">
          <div class="addBtn" @click="handleAdd">新增应用 +</div>
        </div>
    </div> -->
   <div class="content">
     <div class="pageList">
         <!-- <template v-if="active === 0">
           <AuthorizedApp :status="selValue"/>
         </template>
         <template v-if="active === 1"> -->
           <div class="addBtn" @click="handleAdd">发布应用 +</div>
           <ManageApp ref="manageApp" />
         <!-- </template> -->
     </div>
    </div>
    <AppDialog ref="appDialog" @closeAppDialog="closeAppDialog" />
</div>


</template>
<script>
import AuthorizedApp from './components/AuthorizedApp.vue'
import ManageApp from './components/ManageApp.vue'
import AppDialog from './components/AppDialog.vue'
export default {
    data() {
      return {
          active: 0,
          tabList: [
            {
                name: '授权应用'
            },
            {
                name: '管理应用'
            },
          ],
          selValue: 1,
          options: [
            {
              value: 0,
              label: '审核中'
            },
            {
              value: 1,
              label: '审核通过'
            },
            {
              value: 2,
              label: '审核不通过'
            },
          ]
      }
    },
    components: {
      AuthorizedApp,
      ManageApp,
      AppDialog
    },
    methods: {
      tabMenu(index) {
        this.active=index
      },
      goMyApp() {
        this.$router.push({
          name: 'MyApp'
        })
      },
      handleAdd() {
        this.$refs.appDialog.openDialog()
      },
      closeAppDialog() {
        this.$refs.manageApp.refresh()
      }
    }
}
</script>

<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }
  .tabList {
    height: 40px;
    /* display: flex; */
    /* justify-content: flex-start; */
    margin-top: 20px;
    padding-right: 20px;
  }

  .tabList>div.tab {
    cursor: pointer;
    width: 100px;
    margin-left: 40px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    text-align: center;
    display: inline-block;
    line-height: 36px;
  }
   .activeIndex {
    border-bottom: 3px solid #225EFD;
  }
  .content {
    box-sizing: border-box;
    padding: 0px 20px;
    position: relative;
  }
  .pageList {
    width: 100%;
    height: calc(100vh - 180px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 0px 40px;
    /* border: 1px solid #f00; */
  }
  .curLink{
    cursor: pointer;
  }
  .link{
    color: rgba(144, 157, 177, 1);
  }
  .TopRightBox{
    float: right;
    position: relative;
    top: -5px;
  }
  .addBtn{
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    background: #2050D1;
    border-radius: 20px;
    padding: 10px 30px;
    cursor: pointer;
    display: inline-block;
    margin: 20px 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/console/MyApp.vue